module.exports = __webpack_public_path__ + "img/instagram.dbd1c96f.svg";